import { useQueryClient } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { ArrowLeftIcon } from "lucide-react";
import { Link } from "@/core/lib/navigation";
import { PublicSign } from "@/ui/components/ai-documents/public-sign";
import { Button } from "@/ui/components/ui/button";

/**
 * Signing inside the employee portal: the same flow as the public `/sign`
 * page, kept in the portal's shell so the employee never leaves it. Once they
 * sign, the portal's to-do counts and lists refresh.
 */
export const Route = createFileRoute("/portal/sign/$token")({
  component: PortalSignPage,
});

function PortalSignPage() {
  const { token } = Route.useParams();
  const queryClient = useQueryClient();

  return (
    <div className="mx-auto w-full max-w-3xl space-y-6">
      <div className="space-y-1">
        <Button asChild variant="ghost" size="sm" className="-ml-2 gap-1.5">
          <Link href="/portal/documents">
            <ArrowLeftIcon className="size-4" />
            Documents
          </Link>
        </Button>
        <h1 className="font-heading font-semibold text-2xl tracking-tight">Review &amp; sign</h1>
        <p className="text-muted-foreground text-sm">
          Read the document, then add your signature at the end.
        </p>
      </div>
      <PublicSign
        token={token}
        onSigned={() => {
          void queryClient.invalidateQueries({ queryKey: ["portal"] });
        }}
      />
    </div>
  );
}
